/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Home_Link_TelInputs */

const vi_shop_home_link_tel = /** @type {(inputs: Shop_Home_Link_TelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gọi điện`)
};

/**

* @param {Shop_Home_Link_TelInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_home_link_tel = /** @type {((inputs?: Shop_Home_Link_TelInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Home_Link_TelInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_home_link_tel(inputs)
});